import { graphql } from '../../__generated__';

export const USER_EXTERNAL_PORTFOLIO_VALUE = graphql(`
  query UserExternalPortfolioTotalValue {
    userExternalPortfolioTotalValue
  }
`);
